import TourWithAnEnthusiasticLocal from './experiencesData/TourWithAnEnthusiasticLocal';
import RetroPhotoshootInNYC from './experiencesData/RetroPhotoshootInNYC';
import MustHaveLAPicture from './experiencesData/MustHaveLAPicture';
import SunsetTourVankorByBike from './experiencesData/SunsetTourVankorByBike';

const experienceData = [
	// { id: 0, img: "img", permalink: "permalink", title: "Title", city: "City", location: "Location", star: 4.98, price: 3 },

	TourWithAnEnthusiasticLocal,
	RetroPhotoshootInNYC,
	MustHaveLAPicture,
	SunsetTourVankorByBike
];
export default experienceData;